import { render, staticRenderFns } from "./valor_atributo.vue?vue&type=template&id=452ce66d&"
import script from "./valor_atributo.vue?vue&type=script&lang=js&"
export * from "./valor_atributo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports